export class BreadcrumbsLink {
  constructor(public name: string, public url?: string) {}
}
